import React from "react";
import "./Contact.scss";

import { images } from "../../constants";

import { motion } from "framer-motion";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Contact = () => {
  return (
    <div className="contact__container" id="contact">
      <form
        action="https://getform.io/f/93e47ebd-7cb8-474e-b2c0-4301e7b88aa3"
        method="POST"
        className="form__container"
      >
        <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
          className="contact__headline"
        >
          <p className="headline__text"> Contact me</p>
        </motion.div>
        <motion.input
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          type="text"
          placeholder="Your Name"
          name="name"
          className="input__name"
          required
        />
        <motion.input
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          type="email"
          placeholder="Your Email"
          name="email"
          className="input__email"
          required
        />
        <motion.textarea
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          name="message"
          rows="5"
          placeholder="Your Message"
          className="input__message"
          required
        ></motion.textarea>
        <motion.button
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          type="submit"
          value="send"
          className="input__button"
        >
          Submit
        </motion.button>
        <div className="links">
          <a href="https://www.linkedin.com/in/markodju/">
            <img src={images.linkedin} alt="linkedin" className="link" />
          </a>
          <a href="https://github.com/markodju18">
            <img src={images.github} alt="github" className="link" />
          </a>
        </div>
      </form>
    </div>
  );
};

export default Contact;
